import { BehaviorParameters } from 'rangeConfig/@types';
import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { FrameTopComponent, TopPanelSystem } from '@inter-ikea-storageone/range';

const deleteTop = ({ coreApi }: BehaviorParameters) => {
  const selectedEntity = coreApi.entities.findSelectedEntity();
  if (!selectedEntity) return;
  const frame = HierarchyUtils.findWithComponentInUpwardsHierarchy(
    selectedEntity,
    ComponentIds.FRAME_COMPONENT_ID
  );
  const topPanelSystem = coreApi.getSystem<TopPanelSystem>('TopPanelSystem');

  if (frame && topPanelSystem) {
    const top = coreApi.entities.getChildrenWithProductType(
      frame,
      topPanelSystem.topPanelProductType
    );
    if (top.length > 0) {
      frame.addComponent(new FrameTopComponent());
      coreApi.entities.delete(top[0]);
    }
  }
};

export default deleteTop;
